import React from "react";
import { Link } from "react-router-dom";
import LogoPinyadaColor from "../../assets/theme/images/logo-pinyada-color.png";

const NotFound: React.FC = () => {
  return (
    <div className="w-full px-1 bg-[#fcd2d7] min-h-screen">
      <div className="relative w-full  mx-auto px-3 md:px-7 lg:px-6 xl:px-8 py-4 lg:py-4 ">
        <div className="flex items-center justify-between">
          <div className="error-page-logo">
            <div className="bg-white/70 backdrop-blur-sm px-3 py-1.5 md:px-4 md:py-2 rounded-lg shadow-md flex items-center space-x-3">
              <img
                src={LogoPinyadaColor}
                alt="Pinyada Logo"
                className="w-[8rem] h-auto md:w-[10rem] md:h-auto"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full pt-[12rem] pb-[6rem] h-full">
        <div className="flex flex-col items-center text-center bg-[#fcd2d7]">
          <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
          <p className="text-xl text-gray-700 mb-6">Oops! Page not found.</p>
          <Link
            to="/"
            className="px-4 py-2  rounded bg-black text-white rounded-full shadow-md hover:scale-[1.2] transition-transform duration-200"
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
